export const validation = {
  PASSWORD_LENGTH: 6,
};
